<app-modal-layout>
	<div header>
		<span>{{ title }}</span>
	</div>

	<div body>
		<app-notification-set-form-new
			[isUpdating]="service.isUpdating$ | async"
			#nsForm="notificationSetForm"
			[hasSlack]="hasSlack$ | async"
			[hasTeams]="hasTeams$ | async"
			[existingSetNames]="setNames"
			[slackChannels]="channels$"
			(formData)="save($event)"
		>
		</app-notification-set-form-new>
	</div>

	<div footer>
		<app-button [isSecondary]="true" (click)="close()">Close</app-button>
		<app-button [isPrimary]="true" (click)="nsForm.onSubmit()" [disabled]="nsForm.form.invalid || isSubmitting"
			>Create
		</app-button>
	</div>
</app-modal-layout>
